import _ from 'lodash';
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, max, numeric } from 'vee-validate/dist/rules';
import { VueGoodTable } from 'vue-good-table';
import store from '@/store/store';
import PageLoader from '@/components/ui/PageLoader/PageLoader';
import config from '@/config';
import Markups from '@/components/materials/Markups/Markups.vue';
import MaterialsTable from '@/components/materials/MaterialsTable/MaterialsTable.vue';
import MaterialUpload from '@/components/materials/MaterialUpload/MaterialUpload.vue';
import PriceBatchUpdate from '@/components/materials/PriceBatchUpdate/PriceBatchUpdate.vue';
import PercentInput from '@/components/inputs/PercentInput/PercentInput.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faPowerOff,
  faSortDown,
  faTimes,
  faSync,
  faSave
} from '@fortawesome/free-solid-svg-icons';

library.add(faPowerOff, faSortDown, faTimes, faSync, faSave);

export default {
  name: 'price-and-margin',

  data() {
    return {
      activeTexture: null
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      materials: state => state.materials.materials,
      markups: state => state.markups.markups,
      materialTypes: state => state.materials.materialTypes,
      materialGroups: state => state.materials.materialGroups,
      materialSubtypes: state => state.materials.materialSubtypes,
      units: state => state.materials.units
    }),

    constructorId() {
      return this.$route.params.constructorId;
    },

    payload() {
      const { id: firmId } = store.state.user.profile;
      return () => {
        return Promise.all([
          store.dispatch('getMaterialTypes', firmId),
          store.dispatch('getMaterialGroups', firmId),
          store.dispatch('getUnits'),
          store.dispatch('getCommonMarkups', {
            firmId: firmId
          })
        ]);
      };
    }
  },

  watch: {
    firmId(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.$store.dispatch('getMaterials', {
          firmId: newValue,
          constructorId: this.$route.params.constructorId
        });
      }
    }
  },

  methods: {
    openTexturePopup(imgUrl) {
      if (!imgUrl) return;

      this.activeTexture = imgUrl;
      this.$refs.texturePopup.open();
    },

    getMaterialTypeById(id) {
      return this.materialTypes.find(type => type.id === id);
    },

    getMaterialById(materialId) {
      return this.materials.find(material => material.id === materialId);
    },

    updateTableAfterUpload(typeId) {
      _.forEach(this.materialGroups, group => {
        const type = _.find(group.material_types, type => {
          return type.id === typeId;
        });
        if (type) {
          const refId = group.id + '-' + type.id;
          group.collapsed = false;
          type.collapsed = false;
          this.$nextTick(() => {
            this.$refs[refId][0].reset();
            this.$scrollTo(this.$refs[refId][0].$el);
          });
        }
      });
    },

    getUnitById(unitId) {
      const result = this.units.find(unit => {
        return unit.id === unitId;
      });
      return result.title ? result.title : '';
    },

    updateMaterialTypeName(typeId, name) {
      const updatePromise = store.dispatch('updateMaterialTypeName', {
        firmId: this.firmId,
        typeId,
        title: name
      });

      updatePromise.then(() => {
        this.flashSuccess('Название типа материала изменено');
      });
      return updatePromise;
    },

    updateSubtypeName(subtypeId, title) {
      const updatePromise = store.dispatch('updateMaterialSubtypeName', {
        firmId: this.firmId,
        subtypeId,
        data: {
          title
        }
      });

      updatePromise.then(() => {
        this.flashSuccess('Название вида материала изменено');
      });
      return updatePromise;
    },

    updateMaterialTypeWaste(groupId, typeId) {
      return this.$refs[groupId + '-' + typeId + '-observer'][0]
        .validate()
        .then(success => {
          if (!success) {
            return;
          }

          const updatePromise = store.dispatch('updateMaterialTypeMarkup', {
            firmId: this.firmId,
            data: {
              name: 'WASTE_MATERIAL_TYPE',
              markup: parseFloat(this.getMaterialTypeById(typeId).wasteCoeff),
              materialTypeId: typeId
            }
          });

          updatePromise.then(() => {
            this.flashSuccess('Данные о наценке обновлены');
          });
          return updatePromise;
        });
    },

    toPercent(value) {
      return (value * 100).toFixed(0);
    },

    toFloat(value) {
      return (value / 100).toFixed(2);
    },

    validatePercent(e, groupId, typeId) {
      const value = e;
      this.materialTypes.filter(
        type => type.id === typeId
      )[0].wasteCoeff = this.toFloat(value);
      this.$refs[groupId + '-' + typeId + '-provider'][0].syncValue(value);
      this.$refs[groupId + '-' + typeId + '-provider'][0].validate();
    },

    getImageUrl(url) {
      return config.uploadsBase + url;
    },

    zoomDescriptionImage(path) {
      this.$zoom(path, {
        allowZoom: true
      });
    }
  },

  components: {
    VueGoodTable,
    FontAwesomeIcon,
    Markups,
    MaterialsTable,
    MaterialUpload,
    PriceBatchUpdate,
    PercentInput,
    ValidationProvider,
    ValidationObserver,
    PageLoader,
    TutorialModal
  }
};

// Validation rules
extend('required', {
  ...required,
  message: 'Обязательно'
});

extend('max', {
  ...max,
  message: 'Не может быть длиннее 3 цифр'
});

extend('numeric', {
  ...numeric,
  message: 'Может содержать только цифры'
});
